<div class="payment-card" role="listitem">
  <div class="card-header">
    <div class="header-left">
      <mat-icon class="method-icon" aria-hidden="true">receipt_long</mat-icon>
      <span class="method-title">Check</span>
    </div>
    <button mat-icon-button class="delete-btn" (click)="onRemove()" aria-label="Remove check payment method">
      <mat-icon>delete</mat-icon>
    </button>
  </div>

  <div class="card-body">
    <mat-form-field appearance="outline" class="field-check-number">
      <mat-label>Check number</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="method.checkNumber"
        placeholder="Enter check number"
        (blur)="checkNumberTouched = true"
        [attr.aria-invalid]="showCheckNumberError"
        aria-describedby="check-number-error"
        aria-required="true"
        inputmode="numeric"
      />
      <mat-error id="check-number-error" *ngIf="showCheckNumberError">Check number is required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="field-amount">
      <mat-label>Amount</mat-label>
      <span matTextPrefix>$&nbsp;</span>
      <input
        matInput
        type="number"
        appMoney
        [value]="method.amount || ''"
        (input)="onAmountChange($any($event.target).value)"
        min="0"
        step="0.01"
        placeholder="0.00"
        aria-label="Check payment amount"
      />
    </mat-form-field>
  </div>
</div>
